import { EventItem } from "../models/models";

export function formatDate(dateString: string): string {
  const date = new Date(dateString);
  const options: Intl.DateTimeFormatOptions = {
    year: "numeric",
    month: "long",
    day: "numeric",
  };
  return date.toLocaleDateString("en-US", options);
}

export const isUpcoming = (expireDate: string): boolean => {
  const today = new Date();
  const eventEndDate = new Date(expireDate);
  return eventEndDate >= today;
};

export const sortedEventsByExpireDate = (events: EventItem[]): EventItem[] => {
  return [...events].sort((a, b) => {
    return new Date(b.expireDate).getTime() - new Date(a.expireDate).getTime();
  });
};
